/**
 * Whether a person is at the screen. A tab can be visible on a second monitor, or on a laptop left open, with nobody
 * looking: its pollers would keep the person's sandbox awake for ever (every request to it counts as activity), so
 * they pause after INACTIVE_MS without a key, a click, a touch or a scroll, and ask again the moment the person is
 * back (`flow-user-return` on window). A hidden tab is already paused by each poller (document.visibilityState).
 */
export const INACTIVE_MS = 15 * 60 * 1000;
export const USER_RETURN_EVENT = 'flow-user-return';
const INPUT_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'];

let lastInputAt = Date.now();
let override = null;

/** Whether the person did something in the last INACTIVE_MS. */
export const isUserActive = (now = Date.now()) => (override === null ? now - lastInputAt < INACTIVE_MS : override);

/** An input: the person is here; one after a long pause tells the pollers to ask at once. */
export function noteUserInput(now = Date.now()) {
  const wasAway = !isUserActive(now);
  lastInputAt = now;
  if (wasAway && typeof window !== 'undefined') { window.dispatchEvent(new Event(USER_RETURN_EVENT)); }
}

/** Tests only: the last input's time; and a fixed answer (null: the real one) for tests under a fake clock. */
export const setLastInputAt = (at) => { lastInputAt = at; };
export const setUserActiveOverride = (value) => { override = value; };

if (typeof window !== 'undefined') {
  INPUT_EVENTS.forEach((name) => window.addEventListener(name, () => noteUserInput(), { passive: true, capture: true }));
}
